<template>
  <div>
    <technologyVue :isServiceTeacher="1" />
  </div>
</template>

<script>
import technologyVue from '../technology/index.vue'
export default {
  name: 'ServiceTeacher',
  data() {
    return {}
  },
  components: {
    technologyVue
  }
}
</script>
